import { render, staticRenderFns } from "./ViewContactClienteSolcitudInfo.vue?vue&type=template&id=4f0deb50&scoped=true"
import script from "./ViewContactClienteSolcitudInfo.vue?vue&type=script&lang=js"
export * from "./ViewContactClienteSolcitudInfo.vue?vue&type=script&lang=js"
import style0 from "./ViewContactClienteSolcitudInfo.vue?vue&type=style&index=0&id=4f0deb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0deb50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
